/**
 * @module middleware/auth
 * @description Redirect to login page if user is not logged in. This is a global middleware for every page.
 * @param {Object} to - The target Route Object being navigated to.
 * @param {Object} from - The current route being navigated away from.
 * @returns {Promise} - Returns a Promise that resolves to the path of the login page if the user is not logged in.
 */

import { defineNuxtRouteMiddleware, navigateTo } from "nuxt/app"
import { useUserStore } from "../store/user"

export default defineNuxtRouteMiddleware(async (to, from) => {
    const userStore = useUserStore()
    const isTokenInUrl = from.query.token && from.query.token !== ''

    if (!isTokenInUrl && userStore.$state.token === '' && userStore.$state.password === '' && userStore.$state.userName === '' && from.path !== '/login' && to.path !== '/login') {
        return navigateTo('/login')
    }
})
